module.exports = __webpack_public_path__ + "media/landing_work/home/images/full_stack-60e09a5e70ba5bd9bc933ad0f9ceea45.svg";